import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Units, Colors } from 'Css';
import * as Icons from 'components/Material/SvgIcons';

const css = oxygenCss({
  root: {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: 28,
    lineHeight: '24px',
    whiteSpace: 'nowrap',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    marginRight: Units.base,
    fontSize: 12,
    borderRadius: 14,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(235, 235, 235, 0.9)',
    // boxShadow: Shadow[1],
    padding: 2,
    backgroundColor: 'rgba(200, 200, 200, 0.3)',
    color: 'rgba(0, 0, 0, 0.5)',
    '&dense': {
      fontSize: 10,
      height: 16,
      lineHeight: '12px'
    },
    '&dark': {
      border: 'none',
      backgroundColor: Colors.creen,
      color: Colors.darkWhite
    }
  },
  label: {
    verticalAlign: 'middle',
    display: 'inline-block',
    padding: `0 ${Units.base}px`
  },
  button: {
    display: 'inline-block',
    verticalAlign: 'middle',
    cursor: 'pointer',
    outline: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    '>*': {
      verticalAlign: 'middle'
    }
  }
});

class Tag extends Component {
  static propTypes = {
    tag: PropTypes.node,
    onRemove: PropTypes.func,
    dense: PropTypes.bool,
    dark: PropTypes.bool
  };

  remove = () => {
    const { onRemove, tag } = this.props;
    onRemove && onRemove(tag);
  };

  render() {
    const { onRemove, dark, dense, tag } = this.props;
    return (
      <div
        className={classNames(css.root, {
          [css.dense]: dense,
          [css.dark]: dark
        })}
      >
        <div className={css.label}>{tag}</div>
        {onRemove && (
          <button className={css.button} onTouchTap={this.remove}>
            <Icons.NavigationClose />
          </button>
        )}
      </div>
    );
  }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/js/components/Tags/Tag.js